/**
 * @param filters
 * @returns count of active filters
 *
 * @see use with `FilterBuilder component`
 *
 * @example
 * const activeFilterCount = useActiveComponentCountController(filters);
 *
 * @author [Rajkumar Rathod]
 */
export const useActiveComponentCountController = <T>(
  filters: Record<string, T>
) => {
  let count = 0;

  Object.entries(filters).forEach(([_, val]) => {
    if (!!val && val !== undefined && val !== null && val !== "") count++;
    else if (
      typeof val === "object" &&
      val !== null &&
      Object.keys(val).length > 0
    )
      count++;
  });

  return count;
};

export default useActiveComponentCountController;
